import BarcodeReaderComponent from "../../components/BarcodeReader";
import { useDrawerContext } from "../../context/drawerContext";
import CloseIcon from "/public/images/icons/close.svg?react";
import { Link, useNavigate } from "react-router-dom";
import { useUserContext } from "../../context/userContext";
import { useHeaderContext } from "../../context/headerContext";
import { useEffect, useState } from "react";
import Button from "../../components/Button";
import EmailIcon from "/public/images/icons/email.svg?react";
import PhoneIcon from "/public/images/icons/phone.svg?react";
import fetchWithRefresh from "../../utils/fetchWithRefresh";
import { toast } from "react-toastify";
import * as Sentry from "@sentry/react";
import { LogErrors } from "../../utils/LogErrors";

export default function ScanGuestBand() {
  const navigate = useNavigate();
  const { setOpen, setDrawerContent } = useDrawerContext();
  const { setTitle, setSearchFunc } = useHeaderContext();
  const { selectedVenue } = useUserContext();
  const { user, logout, updateTokens } = useUserContext();
  const [ isInitialised, setIsInitialised ] = useState(false);

  useEffect(() => {
    setTitle(false);
    setSearchFunc(false);
  }, []);

  async function finishScanning(detections) {
    await Sentry.startSpan({ name: "Finish Scanning", op: "http.request" }, async (span) => {
      try {
        const url = detections[0].data;
        let iceid = null;
  
        if (url.includes("https://iceid.app?")) {
          iceid = url.split("https://iceid.app?")[1];
        } else if (url.includes("https://iceid.app/?")) {
          iceid = url.split("https://iceid.app/?")[1];
        } else if (url.includes("https://iceid.app/")) {
          iceid = url.split("https://iceid.app/")[1];
        }
  
        setOpen(false);
  
        const req = await fetchWithRefresh(
          import.meta.env.VITE_API_URL + `Scan/BandScan?ScanID=${iceid}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + user.token,
            },
          },
          logout,
          updateTokens,
          (message) => { toast.info(message); }
        );
  
        span.setAttribute("http.status_code", req.status);
        const res = await req.json();
  
        if (res?.OrgId !== selectedVenue?.OrgID) {
          setOpen(true);
          setDrawerContent(
            <div className="w-full">
              <div className="flex items-center justify-between w-full">
                <br />
                <h2 className="leading-5 tracking-widest uppercase text-[12px]">
                  ERROR
                </h2>
                <CloseIcon className="cursor-pointer" onClick={() => setOpen(false)} />
              </div>
              <div className="mt-6 flex flex-col gap-4 justify-stretch">
                <h3 className="text-[24px]">
                  This guest band doesn&apos;t belong to your venue, please contact us.
                </h3>
                <p className="text-sportsDarkGrey">
                  Our offices are open Monday - Friday between 09:00 - 16:30.
                </p>
                <Link className="flex items-center gap-2" to="tel:0800 999 3669">
                  <PhoneIcon />{" "}
                  <Button status="nobg" variant="tertiary" onClick={() => setOpen(false)}>
                    0800 999 3669
                  </Button>
                </Link>
                <Link className="flex items-center gap-2" to="mailto:hello@sportsguardian.com">
                  <EmailIcon />{" "}
                  <Button status="nobg" variant="tertiary" onClick={() => setOpen(false)}>
                    hello@sportsguardian.com
                  </Button>{" "}
                </Link>
              </div>
            </div>
          );
        } else {
          if (res?.ParticipantId === null || res?.ParticipantId === "00000000-0000-0000-0000-000000000000") {
            navigate(`/guest-bands/${iceid}/activate/1`, { state: { band: res } });
          } else {
            setOpen(true);
            setDrawerContent(
              <div className="w-full">
                <div className="flex items-center justify-between w-full">
                  <br />
                  <h2 className="leading-5 tracking-widest uppercase text-[12px]">ERROR</h2>
                  <CloseIcon className="cursor-pointer" onClick={() => setOpen(false)} />
                </div>
                <div className="mt-6 flex flex-col gap-2 justify-stretch">
                  <h3 className="text-[24px]">
                    This band is already assigned to {res?.ParticipantName}. Please scan an unassigned guest band.
                  </h3>
                </div>
              </div>
            );
          }
        }
      } catch (error) {
        Sentry.captureException(error);
        LogErrors(user, logout, updateTokens, "Error during band scanning: " + error);
        span.setStatus("error");
      } finally {
        span.end();
      }
    });
  }  

  function playBeep() {
    const context = new (window.AudioContext || window.webkitAudioContext)();
    const oscillator = context.createOscillator();
    const gainNode = context.createGain();
  
    oscillator.connect(gainNode);
    gainNode.connect(context.destination);
  
    oscillator.type = 'square';
    oscillator.frequency.value = 880; // A5 (higher pitch)
    gainNode.gain.value = 0.1;
  
    oscillator.start();
    oscillator.stop(context.currentTime + 0.1); // 100ms beep
  }

  function onDetected(detections) {
    sessionStorage.setItem("lastCodeScanned", detections[0].data);
    //playBeep();
    finishScanning(detections);
  }

  return (
    <div className="w-full h-svh relative">
       {isInitialised && (
         <div className="absolute top-6 left-6 w-6 h-6 z-50" onClick={() => navigate(-1)}>
         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
             <rect width="24" height="24" rx="4" fill="white"/>
             <path d="M6 18L18 6M6 6L18 18" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
         </svg>
     </div>
       )}

        <BarcodeReaderComponent pageSetIsInitialised={setIsInitialised} onDetected={onDetected} />
    </div>
  );
}
